import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { User } from '../../shared/data-objects/user';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { LoginService } from '../../shared/services/login.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UserDetailsComponent } from '../../manage-users/user-details/user-details.component';
import { HttpErrorResponse } from '@angular/common/http';
import { FeatureToggle } from '../../shared/data-objects/feature-toggle';
import { FeatureToggleService } from '../../shared/services/feature-toggle.service';

const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;

@Component({
    selector: 'app-register-email',
    templateUrl: './register_email.component.html',
    styleUrls: ['./register_email.component.css']
})
export class RegisterEmailComponent implements OnInit {

    emailControl: FormControl;
    email: string;
    emailControlLength = 50;
    submitErrorMessage: any;
    isRequesting: boolean = false;
    formState: number = 1;

    countDownTimer: number = 5;
    cancelCountDownTimer: boolean = false;

    constructor(private loginSvc: LoginService, private router: Router, private sanitizer: DomSanitizer) {
        this.emailControl = new FormControl('', [Validators.compose([
            Validators.required,
            Validators.maxLength(this.emailControlLength),
            Validators.pattern(emailRE)
        ])]);
    }

    ngOnInit(): void {

    }

    submitEmailRegistration() {
        this.isRequesting = true;
        this.submitErrorMessage = '';

        this.loginSvc
            .registerEmail(this.email)
            .subscribe((data: any) => {
                this.isRequesting = false;

                if (!data.new_user) {
                  this.showUserExistsErrorMsg();
                  this.redirectToLogin();
                } else {
                    if (data.token) {
                        // new user created
                        this.formState = 2;
                    } else {
                        // new user already exists, but registration step 2 not completed
                        this.formState = 3;
                    }
                }
            }, (err: any) => {
                console.error(err);

                this.isRequesting = false;
                this.submitErrorMessage = err;
            });
    }

    showUserExistsErrorMsg() {
      this.submitErrorMessage = this.sanitizer.bypassSecurityTrustHtml(
                                  `User already exists with username <i><u>${this.email}</u></i>. <br />
                                  Redirecting to login page in <b> ${this.countDownTimer}
                                  ${this.countDownTimer > 1 ? 'seconds' : 'second' }</b>. <br />`
                                );
    }

    isFormInvalid() {
        return this.emailControl.invalid || ['', undefined, null].indexOf(this.email) > -1;
    }

    redirectToLogin() {
      this.countDownTimer = 4;
      this.cancelCountDownTimer = false;

      const redirect = () => {
        this.router.navigate(['/login'], { queryParams: { u: this.email }});
      };

      const beginCountDownBeforeRedirect = () => {
        const interval = setInterval(() => {
          if (this.cancelCountDownTimer) {
            clearInterval(interval);
          } else {
            this.showUserExistsErrorMsg();

            this.countDownTimer = this.countDownTimer - 1;
            if (this.countDownTimer === -1) {
              clearInterval(interval);
              redirect();
            }
          }
        }, 1000);
      };

      beginCountDownBeforeRedirect();
    }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/register_email/register_email.component.ts